import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/system-warning",

        async list({ page, filters }) {
            const url = this.url(`/${page}`);

            return await Vue.http.get(url, {
                params: {
                    ...filters,
                },
            });
        },

        async status({ id, status }) {
            const url = this.url(`/${id}/status`);

            return await Vue.http.put(url, {
                status,
            });
        },
    },
    base
);
